import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import PackOverview from "./PackOverview";
import PackDetailSections from "./PackDetailSections";
import SectionJumpNav from "./SectionJumpNav";
import { packSectionLinks } from "./packSections";

export { packSectionLinks } from "./packSections";

const formatDate = (value) => value && moment(value).isValid()
  ? moment(value).format("D MMMM YYYY, HH:mm")
  : null;

const PackViewContent = ({ onDownload, pack }) => {
  const navigateToSection = (event, href) => {
    const target = document.getElementById(href.replace(/^#/, ""));
    if (!target) return;

    event.preventDefault();
    const accordionTrigger = target.querySelector(":scope > .wsm-accordion__heading button");
    const needsOpening = accordionTrigger?.getAttribute("aria-expanded") === "false";
    if (needsOpening) accordionTrigger.click();

    window.history.replaceState(null, "", href);
    const scrollToTarget = () => {
      const topBarOffset = 80;
      const targetTop = target.getBoundingClientRect().top + window.scrollY - topBarOffset;
      window.scrollTo({ behavior: "smooth", top: Math.max(0, targetTop) });
    };

    if (needsOpening && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.setTimeout(scrollToTarget, 230);
    } else {
      window.requestAnimationFrame(scrollToTarget);
    }
  };

  const overviewItems = [
    { label: "Pack reference", value: pack.pack_reference || pack.pack_number },
    { label: "Planner", value: pack.planner_name },
    { label: "Engineering Supervisor", value: pack.users?.esusers?.[0]?.name },
    { label: "Project", value: pack.project?.name || pack.project_name || (pack.location?.project?.id ? `${pack.location.project.number || ""} - ${pack.location.project.name || ""}`.replace(/^\s*-\s*|\s*-\s*$/g, "") : null) },
    { label: "Pack type", value: pack.location?.is_multi_possession ? "Multi-possession" : "Single possession" },
    { label: "Possession number", value: pack.location?.possession_no },
    { label: "Week", value: pack.location?.week_no },
    { label: "Planned start", value: formatDate(pack.location?.planned_start_date) },
    { label: "Planned end", value: formatDate(pack.location?.planned_end_date) },
    { label: "Mileage units", value: { milesYards: "Miles / yards", milesChains: "Miles / chains", kilometersMeters: "Km / metres" }[pack.conversion_unit] },
    { label: "WON item number", value: pack.location?.won_item_no },
  ];

  return (
    <div className="wsm-pack-view-content">
      <SectionJumpNav items={packSectionLinks} onNavigate={navigateToSection} />
      <PackOverview items={overviewItems} />
      <PackDetailSections onDownload={onDownload} pack={pack} />
    </div>
  );
};

PackViewContent.propTypes = {
  onDownload: PropTypes.func,
  pack: PropTypes.object.isRequired,
};

export default PackViewContent;
